import React, { useEffect, useState } from "react";
import { GradeStripHeader } from "./styles";
import { IconButton, Tab, Tabs } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { colors } from "theme";
import useUser from "hooks/useUser";
import PlanToggler from "components/PlanToggler";

function GradeStrip({ activeGrade, setActiveGrade, grades, editGrade }) {
  const { getRole } = useUser();
  const role = getRole();
  const [selectedPlan, setSelectedPlan] = useState("")
  const [gradesToggleList, setGradesToggleList] = useState([])
 
  function getGradesList(data) {
    let result = data.map((item, idx) => `Grade ${idx + 1}`);
    setGradesToggleList(result)
  }

  useEffect(() => {
    getGradesList(grades)
  }, [grades, activeGrade])

  useEffect(() => {
    if(selectedPlan) {
      setActiveGrade(gradesToggleList.indexOf(selectedPlan))
    }
  }, [selectedPlan])

  return (
    <GradeStripHeader>
      <PlanToggler plans={gradesToggleList} setSelectedPlan={setSelectedPlan} />

      {/* <Tabs
        value={activeGrade}
        onChange={(_, newValue) => setActiveGrade(newValue)}
        TabIndicatorProps={{
          style: {
            background: colors.primaryColor,
          },
        }}
        sx={{
          marginBottom: "-2px !important",
        }}
      >
        
        {grades.map((_, index) => (
          <Tab
            sx={{
              fontSize: "14px !important",
              textTransform: "none",
              fontWeight: "500 !important",
              fontFamily: "Inter !important",
              border: "none !important",
              marginRight: "14px !important",
              color: "#4a4a4a !important",
              "&.Mui-selected": {
                color: "#231A3D !important",
                marginRight: "14px !important",
                border: "none !important",
              },
            }}
            label={`Grade ${index + 1}`}
            key={index}
            value={index}
          />
        ))}
      </Tabs> */}

      {role === "admin" && (
        <IconButton onClick={editGrade}>
          <EditIcon sx={{ fontSize: 20 }} />
        </IconButton>
      )}
    </GradeStripHeader>
  );
}

export default GradeStrip;
